import React from 'react';
import PropTypes from 'prop-types';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

const chartContainerStyle = {
  width: '100%',
  height: 300,
  margin: '10px',
  background: '#fff',
  borderRadius: 8,
  padding: '10px 0 80px 0px',
  transform: 'rotate(180deg)',
};

const chartTitleStyle = {
  margin: '0 0 16px',
  fontSize: 16,
  color: '#333',
};

const chartFooterStyle = {
  margin: '16px 0 0',
  fontSize: 12,
  color: '#666',
};

const ChartMessage = ({ data }) => {
  if (
    !data
    || !Array.isArray(data)
    || data.length === 0
    || !data[0].data
    || !data[0].data.config
    || !data[0].data.chartConfig
  ) {
    return null;
  }

  const { data: chartData, config, chartConfig } = data[0].data;

  return (
    <div style={chartContainerStyle}>
      {config.title && <h3 style={chartTitleStyle}>{config.title}</h3>}
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={chartData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={config.xAxisKey} />
          <YAxis dx={-15} />
          <Tooltip />
          {Object.entries(chartConfig).map(([key, value]) => (
            <Line
              key={key}
              type="monotone"
              dataKey={key}
              stroke={value.color}
              name={value.label}
              activeDot={{ r: 8 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
      {config.footer && <p style={chartFooterStyle}>{config.footer}</p>}
    </div>
  );
};

ChartMessage.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.shape({
        data: PropTypes.arrayOf(
          PropTypes.object.isRequired,
        ).isRequired,
        config: PropTypes.shape({
          title: PropTypes.string,
          footer: PropTypes.string,
          xAxisKey: PropTypes.string.isRequired,
          description: PropTypes.string,
        }).isRequired,
        chartType: PropTypes.string.isRequired,
        chartConfig: PropTypes.objectOf(
          PropTypes.shape({
            color: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
          }),
        ).isRequired,
      }).isRequired,
    }),
  ),
};

ChartMessage.defaultProps = {
  data: [],
};

export default ChartMessage;
